import {
	gaEvent,
} from '../../js/utils';

const footer = () => {
	const navLinks = document.querySelectorAll('.c-footer a');

	// Navigation tagging tracking
	if (navLinks.length) {
		navLinks.forEach((navLink) => {
			let linkText = navLink.innerText.trim();
			if (linkText === '') {
				if (navLink.hasAttribute('title')) {
					linkText = navLink.getAttribute('title').trim();
				}
			}
			if (linkText !== '') {
				navLink.addEventListener('click', () => {
					gaEvent({
						event: 'navigationInteraction',
						eventCategory: 'Navigation',
						eventAction: 'Footer',
						eventLabel: linkText
					});
				});
			}
		});
	}
};

export default footer;
